{
  "R": [255, 255, 0, 0, 0, 255, 255],
  "G": [0, 255, 255, 255, 0, 0, 0],
  "B": [0, 0, 0, 255, 255, 255, 0],
  "A": [0, 14, 28, 43, 57, 71, 85],
  "I": [0, 43, 85, 128, 170, 213, 255]
}
